export default __webpack_public_path__ + "static/media/WEB_GUITAR_FINAL2.f2fad51f.png";